<template>
    <div>
        <div class="operationReport-title">
            <div>{{$t('MCM.automaticalMaintenanceReport.title')}}</div>
        </div>
        <div class="operationReport-top">
            <operation-report-search></operation-report-search>
        </div>
        <table-operation-report></table-operation-report>
    </div>
</template>

<script>
    import OperationReportSearch from '../operation_report/OperationReportSearch'
    import TableOperationReport from '../operation_report/TableOperationReport'
    export default {
        name: 'OperationReport',
        components: {
            OperationReportSearch,
            TableOperationReport
        }
    }
</script>

<style scoped>
    .operationReport-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .operationReport-title>div:nth-child(1)
    {
        float:left;
    }
    .operationReport-title>div:nth-child(2)
    {
        float:right;
        margin-top: -6px;
    }
    .operationReport-top
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/operation_report/OperationReport.vue